module.exports = __webpack_public_path__ + "static/media/foto1.365abe02.png";